import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Styles from './UsersStatisticsCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { AnalyticsDataCard } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { formatNumber, getEnergyUnit } from 'Utils/Calculations'
import { useTranslation } from 'react-i18next'

const UsersStatisticsCard = ({
  usersStatistics,
  fetchUsersStatistics,
  fetchUsersStatisticsRequestState,
  filter,
  currency,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    fetchUsersStatistics(filter)
  }, [filter])

  const ac = usersStatistics?.data?.avgConsumption.AC ?? 0
  const dc = usersStatistics?.data?.avgConsumption.DC ?? 0
  const overall = usersStatistics?.data?.avgConsumption.overall ?? 0
  const { divisor: acDivisor, unit: acUnit } = getEnergyUnit(ac)
  const { divisor: dcDivisor, unit: dcUnit } = getEnergyUnit(dc)
  const { divisor: allDivisor, unit: allUnit } = getEnergyUnit(overall)
  const period = filter.length > 1 ? filter[1]?.value : filter[0]?.value
  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <div className={Styles.Top}>
        <AnalyticsDataCard
          title={t('Analytics.UsersAdded')}
          subtitle={
            period &&
            t(
              isNaN(Number(period.charAt(0)))
                ? `Analytics.Since${period
                    .charAt(0)
                    .toUpperCase()}${period.slice(1)}`
                : 'Analytics.SinceLastYear',
            )
          }
          percentage={usersStatistics?.data?.newUsersChange}
          primaryValue={formatNumber(usersStatistics?.data?.newUsers)}
          body={` ${
            fetchUsersStatisticsRequestState === RequestState.LOADING ||
            fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
              ? formatNumber(usersStatistics?.data?.totalUsers)
              : '-'
          } ${t('Analytics.TotalUsers')}`}
          isLoading={fetchUsersStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchUsersStatisticsRequestState === RequestState.LOADING ||
              fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.UsersConsumption')}
          primaryValue={`${formatNumber(ac / acDivisor)} ${acUnit}`}
          secondaryValue={`${formatNumber(dc / dcDivisor)} ${dcUnit}`}
          primaryLabel={t('Analytics.Ac')}
          secondaryLabel={t('Analytics.Dc')}
          body={`${
            fetchUsersStatisticsRequestState === RequestState.LOADING ||
            fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
              ? formatNumber(overall / allDivisor)
              : '-'
          } ${allUnit} ${t('Analytics.UserConsumption')}`}
          isLoading={fetchUsersStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchUsersStatisticsRequestState === RequestState.LOADING ||
              fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.UsersTransactions')}
          primaryValue={formatNumber(usersStatistics?.data?.transactions.App)}
          secondaryValue={formatNumber(
            usersStatistics?.data?.transactions.Card,
          )}
          primaryLabel={t('Analytics.App')}
          secondaryLabel={t('Analytics.Card')}
          body={` ${
            fetchUsersStatisticsRequestState === RequestState.LOADING ||
            fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
              ? Math.round(
                  usersStatistics?.data?.transactions.avgPerUser,
                ).toFixed(0)
              : '-'
          } ${t('Analytics.AvgTransactionsCount')}`}
          isLoading={fetchUsersStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchUsersStatisticsRequestState === RequestState.LOADING ||
              fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.Cost')}
          primaryValue={`${formatNumber(
            usersStatistics?.data?.avgSessionCost.AC,
          )} ${currency}`}
          secondaryValue={`${formatNumber(
            usersStatistics?.data?.avgSessionCost.DC,
          )} ${currency}`}
          primaryLabel={t('Analytics.Ac')}
          secondaryLabel={t('Analytics.Dc')}
          body={` ${
            fetchUsersStatisticsRequestState === RequestState.LOADING ||
            fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
              ? formatNumber(
                  usersStatistics?.data?.avgSessionCost.avgRevenuePerUser,
                )
              : '-'
          } ${currency} ${t('Analytics.AvgRevenue')}`}
          isLoading={fetchUsersStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchUsersStatisticsRequestState === RequestState.LOADING ||
              fetchUsersStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchUsersStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  usersStatistics: AnalyticsSelectors.getUsersStatistics(state),
  fetchUsersStatisticsRequestState:
    AnalyticsSelectors.getUsersStatisticsRequestState(state),
})
function mapDispatchToProps(dispatch) {
  return {
    fetchUsersStatistics: (filter) =>
      dispatch(AnalyticsActions.fetchUsersStatistics(filter)),
  }
}
UsersStatisticsCard.propTypes = {
  usersStatistics: PropTypes.object,
  fetchUsersStatistics: PropTypes.func,
  fetchUsersStatisticsRequestState: PropTypes.number,
  filter: PropTypes.array,
  currency: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersStatisticsCard)
